import React, { Component } from 'react';
import { MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBDataTable } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';


class PotentialManagers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            potentialManagerList: [],
            recruitList: [],
            recruits: "0",
            sales: "0",
            hidden: true,
            modalOpen: false
        };
        this.formatter = new Formatter();
        this.onSubmit = this.onSubmit.bind(this);
        this.toggleModalOpen = this.toggleModalOpen.bind(this);
        this.props.loaderOff();
    }

    toggleModalOpen() {
        this.setState({
            modalOpen: false
        });
    }

    async getRecruitDetail(sfId, unitId) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let recruitsResult = await dl.Get('/demonstrator/getrecruitDetail?sfId=' + sfId + '&unitId=' + unitId, 200);
        //this.setState({
        //    recruitList: recruitsResult.data,
        //    modalOpen: true
        //});
        let demRecs = [];
        let rec;
        recruitsResult.data.map((dem) => {
            rec = {
                sfCurrentCode: dem.sfCurrentCode,
                name: dem.firstNames + ' ' + dem.surname,
                recognition: this.formatter.formatCurrency(dem.recognition),
                recruitedBy: dem.recruitedByFirstName + ' ' + dem.recruitedBySurname
            }
            demRecs.push(rec);
        });
        let tableData = {
            columns: [{
                label: 'Code',
                field: 'sfCurrentCode',
                sort: 'asc'
            },
            {
                label: 'Name',
                field: 'name',
                sort: 'asc'
            },
            {
                label: 'Sales',
                field: 'recognition',
                sort: 'asc'
            },
            {
                label: 'Recruited By',
                field: 'recruitedBy',
                sort: 'asc'
            }],
            rows: demRecs
        }
        this.setState({
            recruitList: tableData,
            modalOpen: true
        });
        this.props.loaderOff();
    }

    async onSubmit(event) {
        this.props.loaderOn();
        event.preventDefault();
        var dl = new DataLayer();
        await dl.Get('/common/getpotentialmanagers?recruits=' + event.target.recruits.value + '&sales=' + event.target.sales.value, 200).then((response) => {
            this.setState({
                potentialManagerList: response.data,
                hidden: false
            });
            this.props.loaderOff();
        })
    }

    render() {
        return (
            <div>
                <Header headerText="Potential Managers" hideSearch={true} />
                <form onSubmit={this.onSubmit}>

                    <MDBRow className="mt-3">
                        <MDBCol sm="12">
                            <MDBInput
                                label="Sales Achieved"
                                name="sales"
                                type="number"
                                required
                            />
                            <MDBInput
                                label="Recruits"
                                name="recruits"
                                type="number"
                                required
                            />
                        </MDBCol>
                        <MDBCol md="12" sm="12">
                            <MDBBtn type="submit" className="float-right">Find</MDBBtn>
                        </MDBCol>
                    </MDBRow>
                </form>

                <MDBRow>
                    {
                        this.state.potentialManagerList.length == 0 ? (<div hidden={this.state.hidden}>No Potential Managers Found</div>) : (
                            this.state.potentialManagerList.map((dem) => {
                                return (
                                    <MDBCol xl="3" lg="3" md="4" sm="12" className="mb-r" >
                                        <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                            <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="users" />&nbsp;&nbsp;{dem.unitName}</MDBCardTitle>
                                            <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{dem.sfName}</MDBCardTitle>
                                            <MDBCardTitle style={{ fontSize: "14px" }}>&nbsp;<MDBIcon icon="id-card" />&nbsp;&nbsp;{dem.sfCurrentCode}</MDBCardTitle>
                                            <hr />
                                            <MDBCardText>
                                                <MDBRow>
                                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                                        <span style={{ fontSize: "14px" }}>Personal Sales</span><br /> <strong>{this.formatter.formatCurrency(dem.persSales)}</strong>
                                                    </MDBCol>
                                                    <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "14px" }}>Recruit Sales</span><br /> <strong>{this.formatter.formatCurrency(dem.recSales)}</strong>
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                                        <span style={{ fontSize: "14px" }}>Active Recruits</span><br /> <strong>{dem.activeSF}</strong>
                                                    </MDBCol>

                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol sm="12" style={{ textAlign: "center" }}>
                                                        <MDBBtn rounded color="pink" size="sm" onClick={() => this.getRecruitDetail(dem.sfId, dem.unitId)}><MDBIcon icon="info" />&nbsp;Details</MDBBtn><br />
                                                    </MDBCol>
                                                </MDBRow>
                                            </MDBCardText>
                                            <hr />
                                            <div className="flex-row text-center" >
                                                <span>Total Sales:&nbsp;<strong>{this.formatter.formatCurrency(dem.totalSales)}</strong></span>
                                            </div>
                                        </MDBCard>
                                    </MDBCol>
                                );
                            })
                        )


                    }
                </MDBRow>

                <MDBModal size="lg" isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Potential Manager Recruit List</MDBModalHeader>
                    <MDBModalBody style={{ textAlign: "center" }}>
                        <MDBDataTable
                            responsive
                            striped
                            bordered
                            hover
                            data={this.state.recruitList}
                            paging={false}
                            autoWidth
                        />;
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={this.toggleModalOpen}>Close</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>

        )
    }
}

export default PotentialManagers;


